import { useEvent } from '@mint-lib/hooks';
import { useQuery } from '@mint-lib/query-client';
import { Campaign } from '@mint-sdk/api-campaign-collections';

import { useService } from './useService.js';

export function useCampaignTitle(
  campaignId: string,
): [
  campaignTitle: Campaign.CampaignTitleType | undefined,
  invalidate: () => void,
] {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });
  const { data } = useQuery(
    Campaign.getCampaignTitleQueryOptions({
      urlParams: { campaignId },
    }),
    queryClient,
  );
  const invalidate = useEvent(() => {
    queryClient.invalidateQueries(
      Campaign.getCampaignTitleQueryOptions({
        urlParams: { campaignId },
      }),
    );
  });
  return [data, invalidate];
}

export type CampaignType = Campaign.CampaignType;

export function useCampaign(
  campaignId: string,
): [campaign: CampaignType | undefined, invalidate: () => void] {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
    failOnNotFound: true,
  });
  const { data } = useQuery(
    Campaign.getCampaignQueryOptions({
      urlParams: { campaignId },
    }),
    queryClient,
  );
  const invalidate = useEvent(() => {
    queryClient.invalidateQueries(
      Campaign.getCampaignQueryOptions({
        urlParams: { campaignId },
      }),
    );
  });
  return [data, invalidate];
}
